import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import grey from '@mui/material/colors/grey';
import Box from '@mui/system/Box';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { InfoDialogProvider } from '../infoDialogs';
import { ConfirmDialogProvider } from '../confirmDialogs';
import { defineStyles } from '../theme';
import { TableContainer } from './TableContainer';
const styles = defineStyles({
    dataBox: {
        height: '100%',
        pt: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        '& .MuiTypography-root': {
            textAlign: 'end',
            color: grey[600],
        },
    },
});
export function SmartTable({ shownBuiltInActions, leftActions, rightActions, bulkActions, allowNewColumns, inheritToastContainer, inheritConfirmationDialogsProvider, inheritInfoDialogsProvider, hideMaxRecordsForm, }) {
    let result = (_jsxs(DndProvider, { backend: HTML5Backend, children: [_jsx(Box, { sx: styles.dataBox, children: _jsx(TableContainer, { shownBuiltInActions: shownBuiltInActions, leftActions: leftActions, rightActions: rightActions, bulkActions: bulkActions, allowNewColumns: allowNewColumns, hideMaxRecordsForm: hideMaxRecordsForm }) }), !inheritToastContainer && _jsx(ToastContainer, { position: "bottom-right", hideProgressBar: true, theme: "colored" })] }));
    if (!inheritInfoDialogsProvider) {
        result = _jsx(InfoDialogProvider, { children: result });
    }
    if (!inheritConfirmationDialogsProvider) {
        result = _jsx(ConfirmDialogProvider, { children: result });
    }
    return result;
}
//# sourceMappingURL=SmartTable.js.map